import type { Module, Testimonial, RetargetingAd, FunnelStep } from '../types/funnel'
import { formatUsd } from '../utils/currency'

export const PRICES = {
  blueprint: 6.39,
  blueprintValue: 42.6,
  bump: 17,
  masterclass: 67,
  masterclassValue: 197,
}

export const CHECKOUT_URL = 'https://thesolismethod.com/cart/44410140852289:1'

export const IMAGES = {
  cover: 'https://cdn.magicpatterns.com/uploads/kqnaLSXfTm9QfLVWfEq6uB/portada.png',
  park: 'https://cdn.magicpatterns.com/patterns/generated-images/2e70604c-bbf7-4670-aba3-a02517306baa.jpg',
  sarah: 'https://cdn.magicpatterns.com/patterns/generated-images/5cd05a1e-1b21-4141-ae14-ffb4c196183e.jpg',
  masterclass: 'https://cdn.magicpatterns.com/patterns/generated-images/015a6c82-e8c3-4a5a-83b0-f782a3fbfd75.jpg',
  food: 'https://cdn.magicpatterns.com/patterns/generated-images/396e74ce-1b24-462f-8019-1501629564db.jpg',
}

export const modules: Module[] = [
  {
    number: '01',
    title: 'Protocolo Spine-Shield',
    description:
      'La rutina diaria de 7 minutos para descomprimir la columna y reducir el riesgo de hernia discal (IVDD), la causa #1 de parálisis en la raza.',
  },
  {
    number: '02',
    title: 'Respiración sin jadeo',
    description:
      'Masajes torácicos y control de temperatura para evitar el golpe de calor en verano, incluso en apartamentos sin aire acondicionado.',
  },
  {
    number: '03',
    title: 'Mapa antiinflamatorio de 30 días',
    description:
      'Qué eliminar de la croqueta actual, semana por semana, y los 9 ingredientes que reducen la alergia cutánea y el picor nocturno.',
  },
  {
    number: '04',
    title: 'Pliegues y piel',
    description:
      'El ritual de 90 segundos que corta la dermatitis de pliegue antes de que se convierta en una factura de $400 en el veterinario.',
  },
  {
    number: '05',
    title: 'Checklist de longevidad',
    description:
      'Las 12 señales tempranas que tu veterinario solo detecta en la revisión anual, listas para revisar en casa cada mes.',
  },
]

export const testimonials: Testimonial[] = [
  {
    name: 'Sarah M.',
    location: 'Austin, TX',
    dogAge: 'Bruno, 9 años',
    quote:
      'Bruno arrastraba las patas traseras después de subir escaleras. Tres semanas con la rutina de columna y volvió a saltar al sofá solo. Mi veterinario me pidió el nombre del protocolo.',
    photo: IMAGES.sarah,
  },
  {
    name: 'Daniel R.',
    location: 'Chicago, IL',
    dogAge: 'Momo, 4 años',
    quote:
      'Pasábamos cada verano encerrados por miedo al golpe de calor. Ahora sé exactamente cuándo y cómo sacarlo. Cero episodios este año.',
  },
  {
    name: 'Priya K.',
    location: 'Jersey City, NJ',
    dogAge: 'Olive, 12 años',
    quote:
      'La transición de dieta fue lo que más miedo me daba. Seguí los tiempos al pie de la letra y no tuvimos ni un día de diarrea.',
  },
]

export const retargetingAds: RetargetingAd[] = [
  {
    id: 'ad-1',
    window: 'Día 1 – 2',
    angle: 'Recordatorio de carrito',
    headline: 'Se te olvidó algo...',
    primaryText:
      'Dejaste el Protocolo de Biohacking a medio camino. Tu Frenchie sigue esperando esos 7 minutos al día. Tu acceso queda reservado unas horas más.',
    cta: 'Completar mi pedido',
    creativeNote: 'Imagen del ebook + iPad sobre fondo crema, sin texto encima.',
    audience: 'Visitaron Checkout, no compraron · 2 días',
  },
  {
    id: 'ad-2',
    window: 'Día 3 – 5',
    angle: 'Prueba social',
    headline: 'Mira lo que dice Sarah sobre el cambio en su Frenchie',
    primaryText:
      '"Bruno arrastraba las patas traseras al subir escaleras. Tres semanas después volvió a saltar al sofá solo." — Sarah M., Austin, TX.',
    cta: 'Leer la historia completa',
    creativeNote: 'Foto real de Sarah con Bruno + cita corta en overlay inferior.',
    audience: 'Vieron Sales Page, no compraron · 5 días',
  },
  {
    id: 'ad-3',
    window: 'Día 6 – 7',
    angle: 'Urgencia',
    headline: 'Última oportunidad: el descuento del 85% expira hoy',
    primaryText: `Hoy es el último día en que el Protocolo completo se queda en ${formatUsd(
      PRICES.blueprint,
    )} en lugar de ${formatUsd(PRICES.blueprintValue)}. Mañana vuelve a precio de lista.`,
    cta: 'Asegurar mi acceso',
    creativeNote: 'Contador de tiempo estático + sello "85% OFF" sobre fondo azul marino.',
    audience: 'Todo el tráfico frío de 7 días, excluye compradores',
  },
]

export const funnelSteps: FunnelStep[] = [
  { path: '/', label: 'Bridge Page', detail: 'Educación + pre-sell' },
  { path: '/protocolo', label: 'Sales Page', detail: `Oferta de ${formatUsd(PRICES.blueprint)}` },
  { path: '/checkout', label: 'Checkout', detail: `Order bump $${PRICES.bump}` },
  { path: '/oferta-especial', label: 'OTO 1', detail: `Upsell $${PRICES.masterclass}` },
  { path: '/gracias', label: 'Thank You', detail: 'Entrega + onboarding' },
  { path: '/retargeting', label: 'Retargeting', detail: 'Ads de $2/día' },
]
